import * as React from "react";

import { Select, TextInput } from "../../../Base/Fields";

// store, state
import { constants } from "../../../../../store/tenantPortalSettings";
import {
  OverviewSubtitle,
  OverviewTitle,
  OverviewTitleWithSubtitleWrapper,
  OverviewTitleWrapper,
} from "../../../../Details/OverviewInfo/styles";

const FRESHCHAT_OPTIONS = [
  { d: "Namn", v: "name" },
  { d: "E-postadress", v: "email" },
  { d: "Telefonnummer", v: "phone" },
  { d: "Lägenheter/Lokaler", v: "premises" },
  { d: "Hyresgästnummer", v: "customer_id" },
];

export default ({ method }) => {
  const storeName = constants.STORE_NAME;

  return (
    <>
      <OverviewTitleWrapper>
        <OverviewTitleWithSubtitleWrapper>
          <OverviewTitle>Freshchat integration</OverviewTitle>
          <OverviewSubtitle>
            Fyll i token och vilken data som ska skickas till Freschchat vid
            initierad chatt
          </OverviewSubtitle>
        </OverviewTitleWithSubtitleWrapper>
      </OverviewTitleWrapper>

      <hr />

      <TextInput
        storeName={storeName}
        method={method}
        title="Freshchat token"
        fieldKey="freshchat_token"
        description="Denna token kan hämtas ifrån Freshchat under Web Messenger Settings inne i admingränssnittet. Exempel på hur token kan se ut: l67431f3-kl53-4cd5-be2b-d55p92982o97"
      />

      <Select
        isMulti
        method={method}
        storeName={storeName}
        fieldKey="freschat_attributes"
        forceChoices={FRESHCHAT_OPTIONS}
        title="Data som ska skickas till Freshchat vid initierad chatt"
        description="Detta är den datan som dyker upp på kundkortet inne i Freshchat. Observera att det är kontoinnehavarens ansvar att data som lämnas ut till tredjeparter följer bolagets policy."
      />
    </>
  );
};
